import { join } from 'ramda';

import { parseNumberUnless, isRangeMaxSafeInteger, isRangeMinSafeInteger } from './rangeNumberConversion';

const RANGE_SEPARATOR = ':';

/**
 * Ensures that `-900719925474099` and `9007199254740991` are omitted from the URL for any number ranges.
 *
 * Since SearchNumberRange provides individual min and max inputs, checking for them separately
 * @param displayValue
 * @returns
 */
export const toNumberRangeRouteValue = (displayValue: string | undefined) => {
  const range = displayValue?.split(RANGE_SEPARATOR);
  if (!range || range.length !== 2) {
    return displayValue;
  }

  const result = join(RANGE_SEPARATOR, [
    parseNumberUnless(isRangeMinSafeInteger)(range[0]), // range's min
    parseNumberUnless(isRangeMaxSafeInteger)(range[1]), // range's max
  ]);

  // if the result is just the RANGE_SEPARATOR, excluding the filter from route as non-relevant
  return result !== RANGE_SEPARATOR ? result : undefined;
};
